module.exports = __webpack_public_path__ + "images/skewness-02-faq-desktop.png";